import { render, staticRenderFns } from "./ArticleLinkedIn.vue?vue&type=template&id=84dadf7c&scoped=true"
import script from "./ArticleLinkedIn.vue?vue&type=script&lang=js"
export * from "./ArticleLinkedIn.vue?vue&type=script&lang=js"
import style0 from "./ArticleLinkedIn.vue?vue&type=style&index=0&id=84dadf7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dadf7c",
  null
  
)

export default component.exports